import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import MultiSizeFieldArray, { sizesForSubmit } from "../../common/multiSizeFieldArray";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../common/breadcrumbs";
import * as subcategoryServices from "../../services/subCategory";
import { SWAL_SETTINGS, INPUT_LENGTH_500 } from "../../../../utils/Constants";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import { Tooltip, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import CustomCkeditor from "../../common/customeditor";
import StatusFilter from "../../common/statusFilter";
import CategorySelect from "../../common/categorySelect";



const SubCategoryAdd = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [list, setList] = useState([]);

  const { state } = useLocation();
  const { t } = useTranslation()
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const location = useLocation();

  const [statsupdate, setStatusUpdate] = useState("false");

  const [datalength, setDataLength] = useState();
  const [itemperpage] = useState(100);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [initialValues, setInitialValues] = useState({
    title: "",
    title_ja: "",
    name: "",
    categoryId: "",
    slug: "",
    description: "",
    short_description_ja: "",
    meta_tags: "",
    meta_keyword: "",
    richtext: "",
    title_de: "",
    richtext_ja: "",
    sizes: [{ title: "" }],
  });



  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard/1" },
    { title: t("link_category"), url: "/admin/category/list/1" },
    { title: t("link_add"), url: "" },
  ];




  useEffect(() => {
    setInitialValues({
      title: state && state?.title ? state?.title : "",
      title_ja: state && state?.title_ja ? state?.title_ja : "",
      categoryId: state && state?.categoryId ? state?.categoryId : "",

      slug: state && state?.slug ? state?.slug : "",
      status: state && state?.status ? state.status : "",
      menu_location: state && state?.menu_location ? state.menu_location : "",
      description: state && state?.description ? state?.description : "",
      short_description_ja: state && state?.short_description_ja ? state?.short_description_ja : "",
      richtext: state && state?.description ? state?.description : "",
      richtext_ja: state && state?.richtext_ja ? state?.richtext_ja : "",
      sizes: [{ title: "" }],
    });
    setDataLoaded(true);
  }, []);
  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", page);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        subcategoryServices
          .CategoryList(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            let fetchedList = data && data.data && data.data.list ? data.data.list : [];
            fetchedList = fetchedList.map(cat => {
              if (cat.type) {
                const typeCapitalized = cat.type.charAt(0).toUpperCase() + cat.type.slice(1);
                return { ...cat, title: `${cat.title} (${typeCapitalized})` };
              }
              return cat;
            });
            setList(fetchedList);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);

    return () => clearTimeout(getData);
  }, [location, statsupdate, sorting, search, globalsearch]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <>
          <Formik
            initialValues={initialValues}
            validateOnBlur={false}
            validate={(values) => {
              const error = {};
              if (!values.title || !values.title.trim()) error.title = "label_title_error";
              if (!values.categoryId || !values.categoryId.trim()) error.categoryId = "label_category_id_error";
              if (values.title.length > INPUT_LENGTH_500) error.title = "validation_err_reached_maximum_length";
              if (!values.description || !values.description.trim()) error.description = "label_description_error";
              // if (!values.sizes?.some((s) => s?.title?.trim())) {
              //   error.sizes = t("validation_err_size_required");
              // }
              // if (values.sizes?.length) {
              //   values.sizes.forEach((element, i) => {
              //     if (element.title && element.title.length > INPUT_LENGTH_500) {
              //       if (!Array.isArray(error.sizes)) error.sizes = [];
              //       error.sizes[i] = {
              //         title: t("validation_err_reached_maximum_length"),
              //       };
              //     }
              //   });
              // }
              // if (Array.isArray(error.sizes) && error.sizes.length) {
              //   let flag = 0;
              //   error.sizes.forEach((el) => {
              //     if (el && Object.keys(el).length) flag++;
              //   });
              //   if (!flag) delete error.sizes;
              // }

              // return error;
            }}
            onSubmit={(values, { setSubmitting, resetForm }) => {


              setSubmitted(true);
              globalLoader(true);
              console.log(values);
              let formData = new FormData();
              formData.append("title", values.title);
              formData.append("description", values.description);
              formData.append("categoryId", values.categoryId);
              // formData.append("sizes", JSON.stringify(sizesForSubmit(values.sizes)));
              subcategoryServices
                .Add(formData)
                .then((response) => {
                  setSubmitting(false);
                  if (response.success) {
                    Swal.fire({
                      icon: "success",
                      text: response.message,
                      ...SWAL_SETTINGS,
                    });
                    setTimeout(() => {
                      resetForm({ values: "" });
                      globalLoader(false);
                      navigate(`/admin/subcategory/list/1`);
                    }, 1000);
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: handleServerValidations(response),
                      ...SWAL_SETTINGS,
                    });
                    setSubmitted(false);
                    globalLoader(false);
                  }
                })
                .catch((error) => {
                  console.log("error ====> ", error);
                });
            }}>
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched, isSubmitting }) => (
              <form onSubmit={handleSubmit}>
                <div className="row row-sm">
                  <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                      <div className="card-body">
                        <div>
                          <h6 className="main-content-label mb-3">{t("add_subcategory")}</h6>
                        </div>

                        <div className="row row-sm">
                          <div className="col-lg-12 text-center form-group">
                            <label htmlFor="title" className="text-left d-flex">
                              {t("list_heading_category")}:<span className="requirestar">*</span>
                            </label>
                            <div className="">
                              <CategorySelect
                                data={list}
                                value={values.categoryId}
                                onChange={(value) => {
                                  setFieldValue("categoryId", value);
                                  setFieldTouched("categoryId", true);
                                }}
                              />
                            </div>
                            <span className="text-danger d-flex text-left">{errors.categoryId && touched.categoryId && t(errors.categoryId)}</span>
                          </div>
                          <div className="col-lg-12 text-center form-group">
                            <label htmlFor="title" className="text-left d-flex">
                              {t("list_heading_title")}:<span className="requirestar">*</span>
                              {/* <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("admin.pages.tooltip_page_title")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper> */}
                            </label>
                            <input name="title" id="title" type="text" onChange={handleChange} onBlur={handleBlur} value={values.title} className="form-control" placeholder={t("subcategory_title_placeholder")} />
                            <span className="text-danger d-flex text-left">{errors.title && touched.title && t(errors.title)}</span>
                          </div>
                          <div className="col-lg-12 text-center form-group">
                            <label htmlFor="description" className="text-left d-flex">
                              {t("label_description")}:<span className="requirestar">*</span>
                            </label>
                            <textarea name="description" type="text" onChange={handleChange} onBlur={handleBlur} value={values.description} className="form-control" placeholder={t("faq_description_placeholder")} rows="5" />
                            {/* <CustomCkeditor
                            fieldname={"description"}
                            setFieldValue={setFieldValue}
                            value={values.description}
                            setFieldTouched={setFieldTouched}
                          /> */}
                            <span className="text-danger d-flex text-left">{errors.description && touched.description && t(errors.description)}</span>
                          </div>
                          {/* <MultiSizeFieldArray values={values} errors={errors} name="sizes" />*/}
                          <div className="">
                            <button className="btn btn-main-primary signbtn mr-2" type="submit" disabled={submitted ? true : null}>
                              <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                              {t("btn_submit")}
                            </button>
                            <button className="btn ripple btn-secondary" type="button" disabled={submitted ? true : null} onClick={() => navigate(-1)}>
                              <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                              {t("btn_cancel")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default SubCategoryAdd;
